<template>
  <div
    @click.stop="toDetail(item)"
    class="list-item" :class="{
      'list-item-normal': size === 'normal',
      'list-item-small': size === 'small',
      'list-item-big': size === 'big',
    }">
    <div class="imgBox">
      <img class="icon-pdf" src="@/assets/icon/icon_pdf.png">
    </div>
    <div class="info">
      <h3>{{ item.title }}</h3>
      <div class="num">
        <span>{{ item.viewCount }} 人浏览</span>
        <van-icon name="eye-o" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import app from '@/widget/app'
import utils from '@utils/index'
import { hostPath } from '@utils/basePath'
export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    toDetail (item) {
      if (utils.isApp()) {
        app.postMessage({
          type: 'h5',
          url: `${hostPath}/learn/pdf/viewer?url=${item.pdfPath}&name=${item.pdfName}`
        })
      } else {
        this.$router.push({
          name: 'PdfViewer',
          query: {
            url: item.pdfPath,
            name: item.pdfName
          }
        })
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.list-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .info {
    overflow: hidden;
    flex: 1;
    h3 {
      min-height: 40px;
      max-height: 80px;
      line-height: 40px;
      font-size: 28px;
      margin-bottom: 8px;
      @include multi-ellipsis(2);
      font-weight: normal;
    }
    .num {
      height: 34px;
      line-height: 34px;
      color: $gray96;
      display: flex;
      justify-content: space-between;
      font-size: 24px;
    }
  }
  .imgBox {
    width: 54px;
    height: 62px;
    margin-top: 8px;
    margin-right: 16px;
  }
}

</style>
